import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import { getEnv } from 'utils';

export default function InfodesignGraphicalAbstract() {
  const classes = useStyles();

  return (
    <Box px={6} py={6}>
      <Grid item xs={12}>
        <Typography className={classes.title} component="h2">
          Professional graphical abstracts with no effort!
        </Typography>

        <Typography className={classes.subtitle}>
          We built Mind the Graph for simplicity. The platform is easy to use and just about anybody
          <br />
          can use it to <a href={`${getEnv('MTG_URL_APP')}/`}>create great infographics </a> and
          presentations - from beginners to professionals,
          <br />
          individuals to groups and small labs to large organizations
        </Typography>
      </Grid>

      <Grid className={classes.itemContainer} container={true} spacing={8}>
        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img src="/images/publish-icon.svg" loading="lazy" alt="Publish everywhere" />

            <Typography className={classes.titleOptions}>Publish everywhere</Typography>

            <Typography className={classes.textOptions}>
              Need to follow specific guidelines?
              <br />
              Easily adjust illustrations, fonts,
              <br />
              templates, texts, and file size
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img src="/images/premade-icon.webp" loading="lazy" alt="Pre-made resources" />

            <Typography className={classes.titleOptions}>Pre-Made Resources</Typography>

            <Typography className={classes.textOptions}>
              Don't waste time! Use our graphical
              <br />
              abstract templates and just
              <br />
              customize colors, text, etc.
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img src="/images/slides-icon.webp" loading="lazy" alt="Online Platform" />

            <Typography className={classes.titleOptions}>Online Platform</Typography>

            <Typography className={classes.textOptions}>
              Access your graphical abstract
              <br />
              at any time and from anywhere.
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img src="/images/ondemand-icon.webp" loading="lazy" alt="On-demand illustrations" />

            <Typography className={classes.titleOptions}>On-demand Illustrations</Typography>

            <Typography className={classes.textOptions}>
              Don't find exactly what you need?
              <br />
              We will design it for you!
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img src="/images/online-platform-icon.webp" loading="lazy" alt="Online plataform" />

            <Typography className={classes.titleOptions}>Slides Presentations</Typography>

            <Typography className={classes.textOptions}>
              Integrate graphical abstracts
              <br />
              into beautiful and impactful slides
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/multiple-sizing-options-icon.webp"
              loading="lazy"
              alt="Download in various formats and high resolution"
            />

            <Typography className={classes.titleOptions}>
              Download in various <br /> formats and high resolution
            </Typography>

            <Typography className={classes.textOptions}>
              Download your graphical abstract
              <br />
              as PDF, TIFF, or PNG file format
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
